var RobotInstanceStatus;
(function (RobotInstanceStatus) {
    RobotInstanceStatus["SENDING"] = "SENDING";
    RobotInstanceStatus["SYNCING"] = "SYNCING";
    RobotInstanceStatus["RUNNING"] = "RUNNING";
    RobotInstanceStatus["READY"] = "READY";
})(RobotInstanceStatus || (RobotInstanceStatus = {}));
export default RobotInstanceStatus;
